import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogoPopUp } from "@sharedV11/components/alert/dialog/popup.service";
import { InputFilterComponent } from "@sharedV11/components/input-filter/input-filter.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { from, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  take,
  takeUntil,
} from "rxjs/operators";
import {
  appendTxTaxonomySuffix,
  normalizeTaxonomiaNivelNombreForDisplay,
  txTaxonomyFieldLabel,
} from "src/app/shared/utils/column-label.util";
import { Paginator } from "@sharedV11/classes/paginator/paginator";

@Component({
  selector: "app-edit-asociar-tx",
  templateUrl: "./edit-asociar-tx.component.html",
  styleUrls: ["./edit-asociar-tx.component.scss"],
})
export class EditAsociarTxComponent implements OnInit, OnDestroy {
  @ViewChildren(InputFilterComponent)
  private headerInputFilters: QueryList<InputFilterComponent>;

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar = false;
  @Input() otherProps: { [key: string]: any };

  editForm: FormGroup;
  loading = false;
  translation: any = {};
  private destroy$ = new Subject<void>();
  private initialFormValue: any;
  private initialTxNiveles: { [n: number]: any[] } = {};
  private initialRevenueCategoryInfo = "";
  private initialCuentaVisitanteInfo = "";
  private initialHasRevenueCategoryValue = false;
  private initialHasCuentaVisitanteValue = false;
  private initialUltimoNivelLeaf: any = null;
  submitValidationTick = 0;
  inputFilterUiSyncKey = 0;
  /** Mantém o aviso * Campo requerido no 1.º Guardar (Nombre Producto). */
  productoSubmitRequiredLatch = false;

  private suppressProductoTaxonomiaApply = false;
  private taxonomiaEntradaApplySeq = 0;
  /** Panel abierto por duplicar fila: al elegir otro producto Entrada con taxonomía en maestros, confirmar antes de aplicar. */
  private itemVentaTxDuplicateProductoFlow = false;
  /** Último ProductoId aceptado sin modal (incluye el copiado al abrir el duplicado). */
  private itemVentaTxDuplicateLastProductoIdSinModal: number | null = null;

  tiposProducto: { value: number; name: string }[] = [];
  siNoOptions: { value: number; name: string }[] = [];
  private rawCuentaVisitanteDisplayed: any = undefined;
  private initialRawCuentaVisitante: any = undefined;

  productosOptions: any[] = [];
  txCentroCosteOptions: any[] = [];
  txTipoPrecioOptions: any[] = [];
  txCanalVentasOptions: any[] = [];
  txAlojamientoOptions: any[] = [];
  txNiveles: { [nivel: number]: any[] } = {};
  ultimoNivelLeaf: any = null;
  revenueCategoryInfo = "";
  cuentaVisitanteInfo = "";
  hasRevenueCategoryValue = false;
  hasCuentaVisitanteValue = false;
  loadedTipoNombre = "";
  loadedProductoNombre = "";

  constructor(
    private fb: FormBuilder,
    private panelService: PanelService,
    private servicioAPI: ConectarApiService,
    private translator: Translator,
    private httpErrorService: HttpErrorsService,
    private snackbar: SnackbarInfoService,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {
    this.editForm = this.fb.group({
      pkId: [0],
      TipoProducto: [null, [Validators.required]],
      ProductoId: [null, [Validators.required]],
      TXCentroCosteId: [null, [Validators.required]],
      TXTipoPrecioId: [null, [Validators.required]],
      TXCanalVentasId: [null, [Validators.required]],
      TXAlojamientoId: [0],
      TXItemVentasId: [null],
      Nivel1: [null, [Validators.required]],
      Nivel2: [null],
      Nivel3: [null],
      Nivel4: [null],
      Nivel5: [null],
      Nivel6: [null],
      Nivel7: [null],
    });
  }

  ngOnInit(): void {
    this.translation = this.translator.GetTranslations();
    this.syncTiposProductoSiNoI18n();
    this.translator.dataLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.translation = this.translator.GetTranslations();
        this.syncTiposProductoSiNoI18n();
        if (
          this.rawCuentaVisitanteDisplayed !== undefined &&
          this.hasCuentaVisitanteValue
        ) {
          this.cuentaVisitanteInfo = this.textoCuentaVisitante(
            this.rawCuentaVisitanteDisplayed
          );
        }
        this.cdRef.markForCheck();
      });
    if (this.isUpdateMode) {
      this.relaxProductHeaderValidatorsForModify();
    }
    this.loading = true;
    this.registerWatchers();
    this.loadInitialData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async discard(): Promise<void> {
    if (!this.initialFormValue) {
      return;
    }
    this.productoSubmitRequiredLatch = false;
    this.suppressProductoTaxonomiaApply = true;
    try {
      this.editForm.reset(this.initialFormValue, { emitEvent: false });
      for (let n = 1; n <= 7; n++) {
        this.txNiveles[n] = [...(this.initialTxNiveles[n] || [])];
      }
      this.revenueCategoryInfo = this.initialRevenueCategoryInfo;
      this.cuentaVisitanteInfo = this.initialCuentaVisitanteInfo;
      this.rawCuentaVisitanteDisplayed = this.initialRawCuentaVisitante;
      this.hasRevenueCategoryValue = this.initialHasRevenueCategoryValue;
      this.hasCuentaVisitanteValue = this.initialHasCuentaVisitanteValue;
      this.ultimoNivelLeaf = this.initialUltimoNivelLeaf;
      for (let n = 2; n <= 7; n++) {
        this.actualizarValidadorNivel(n, (this.txNiveles[n] || []).length > 0);
      }
      const tipo = this.editForm.get("TipoProducto")?.value;
      if (tipo) {
        await this.onTipoProductoChanged(tipo, false);
      } else {
        this.productosOptions = [];
      }
    } finally {
      this.suppressProductoTaxonomiaApply = false;
    }
    if (this.itemVentaTxDuplicateProductoFlow) {
      const dpid = Number(this.editForm.get("ProductoId")?.value);
      this.itemVentaTxDuplicateLastProductoIdSinModal =
        Number.isFinite(dpid) && dpid > 0 ? dpid : null;
    }
    this.inputFilterUiSyncKey++;
    this.panelService.setDiscardChanges(true);
    this.cdRef.detectChanges();
  }

  private captureDiscardSnapshot(): void {
    this.initialFormValue = this.editForm.getRawValue();
    this.initialTxNiveles = {};
    for (let i = 1; i <= 7; i++) {
      this.initialTxNiveles[i] = [...(this.txNiveles[i] || [])];
    }
    this.initialRevenueCategoryInfo = this.revenueCategoryInfo;
    this.initialCuentaVisitanteInfo = this.cuentaVisitanteInfo;
    this.initialRawCuentaVisitante = this.rawCuentaVisitanteDisplayed;
    this.initialHasRevenueCategoryValue = this.hasRevenueCategoryValue;
    this.initialHasCuentaVisitanteValue = this.hasCuentaVisitanteValue;
    this.initialUltimoNivelLeaf = this.ultimoNivelLeaf;
  }

  closePanel() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  get showAlojamiento(): boolean {
    return Number(this.editForm.get("TipoProducto")?.value) === 1;
  }

  get infoLabelRevenueCategory(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return t.RevenueCategory || t.CategoriaIngresos || "";
  }

  get infoLabelCuentaVisitante(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return t.CuentaVisitante || "";
  }

  private syncTiposProductoSiNoI18n(): void {
    const t = this.translator.GetTranslations() || this.translation || {};
    this.tiposProducto = [
      { value: 1, name: t.TipoProductoEntrada ?? "Entrada" },
      { value: 2, name: t.TipoProductoPromocion ?? "Promoción" },
      { value: 3, name: t.TipoProductoTAbonado ?? "T Abonado" },
    ];
    this.siNoOptions = [
      { value: 1, name: t.Si ?? "Si" },
      { value: 0, name: t.No ?? "No" },
    ];
  }

  private assignCuentaVisitanteInfo(raw: any): void {
    this.rawCuentaVisitanteDisplayed = raw;
    this.cuentaVisitanteInfo = this.textoCuentaVisitante(raw);
  }

  private clearCuentaVisitanteInfo(): void {
    this.rawCuentaVisitanteDisplayed = undefined;
    this.cuentaVisitanteInfo = "";
  }

  get hasTipoSeleccionado(): boolean {
    const value = this.editForm.get("TipoProducto")?.value;
    return value !== null && value !== undefined && String(value).trim() !== "";
  }

  get hintSeleccioneTipoParaProductoHtml(): SafeHtml {
    const fallback =
      "Seleccione el campo <strong>Tipo</strong> para habilitar el campo <strong>Nombre Producto</strong>.";
    const raw = this.translation?.SeleccioneTipoParaNombreProducto ?? fallback;
    return this.sanitizer.bypassSecurityTrustHtml(String(raw));
  }

  get productoDisabled(): boolean {
    return !this.hasTipoSeleccionado || !this.productosOptions?.length;
  }

  get productoPlaceholder(): string {
    if (!this.hasTipoSeleccionado) {
      return (
        this.translation?.SeleccioneTipoPrimero ||
        "Seleccione Tipo primero"
      );
    }
    return this.translation?.NombreProducto || "Nombre producto";
  }

  showProductoNombreRequeridoDebajo(): boolean {
    if (this.isUpdateMode || !this.hasTipoSeleccionado) {
      return false;
    }
    return this.productoSubmitRequiredLatch;
  }

  private isProductoIdValorValido(value: any): boolean {
    const n = Number(value);
    return Number.isFinite(n) && n > 0;
  }

  private isProductoIdInOptionsList(pk: any): boolean {
    const id = Number(pk);
    if (!Number.isFinite(id) || id <= 0) {
      return false;
    }
    const list = this.productosOptions;
    if (!Array.isArray(list)) {
      return false;
    }
    return list.some(
      (p) =>
        p &&
        (Number(p.pkId) === id ||
          String(p.pkId ?? "").trim() === String(id))
    );
  }

  get isUpdateMode(): boolean {
    return this.mode === "U";
  }

  get isDuplicateMode(): boolean {
    return this.mode === "D";
  }

  validateFields(field: string): boolean {
    const c = this.editForm.get(field);
    return !!(c && c.invalid && (c.touched || c.dirty));
  }

  getRequiredError(): string {
    return this.translation?.CampoRequerido || "Campo requerido";
  }

  nivelTxMatLabel(level: number): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    const nivelWord = String(t.Nivel ?? "Nivel").trim();
    return appendTxTaxonomySuffix(`${nivelWord} ${level}`);
  }

  get labelTxCentroCoste(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return txTaxonomyFieldLabel(t, "CentroCoste", "Centro coste");
  }

  get labelTxTipoPrecio(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return txTaxonomyFieldLabel(t, "TipoPrecio", "Tipo precio");
  }

  get labelTxCanalVentas(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return txTaxonomyFieldLabel(t, "CanalVentas", "Canal ventas");
  }

  get labelTxAlojamiento(): string {
    const t = this.translator.GetTranslations() || this.translation || {};
    return txTaxonomyFieldLabel(t, "Alojamiento", "Alojamiento");
  }

  compareByNivelNombre = (a: any, b: any): boolean => {
    return (
      !!a &&
      !!b &&
      String(a.NivelNombre ?? "").trim() === String(b.NivelNombre ?? "").trim()
    );
  };

  displayTaxonomiaNivelNombre(item: any): string {
    return normalizeTaxonomiaNivelNombreForDisplay(item?.NivelNombre);
  }

  private coerceNumericId(value: any): any {
    if (value === null || value === undefined) {
      return value;
    }
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
    const s = String(value).trim();
    if (s !== "" && /^\d+$/.test(s)) {
      return Number(s);
    }
    return value;
  }

  private parseIncomingInputFilterValue(value: any): any {
    if (value === "" || value === "-1" || value === undefined || value === null) {
      return null;
    }
    return this.coerceNumericId(value);
  }

  private getInputFilterListByControl(controlName: string): any[] {
    switch (controlName) {
      case "TipoProducto":
        return this.tiposProducto || [];
      case "ProductoId":
        return this.productosOptions || [];
      case "TXCentroCosteId":
        return this.txCentroCosteOptions || [];
      case "TXTipoPrecioId":
        return this.txTipoPrecioOptions || [];
      case "TXCanalVentasId":
        return this.txCanalVentasOptions || [];
      case "TXAlojamientoId":
        return this.txAlojamientoOptions || [];
      default:
        return [];
    }
  }

  private resolveInputFilterValueFromMethods(ev: any): any {
    const fn = ev?.methods?.getSyncValueForParentForm;
    if (typeof fn !== "function") return null;
    const value = fn();
    return this.parseIncomingInputFilterValue(value);
  }

  private normalizeListLabel(s: any): string {
    return (s ?? "").toString().trim().replace(/  +/g, " ");
  }

  private resolveValueByVisibleText(controlName: string, visibleText: any): any {
    const txt = this.normalizeListLabel(visibleText);
    if (!txt) return null;
    const list = this.getInputFilterListByControl(controlName);
    if (!list.length) return null;

    const mapConfig: Record<string, { text: string; value: string }> = {
      TipoProducto: { text: "name", value: "value" },
      ProductoId: { text: "Nombre", value: "pkId" },
      TXCentroCosteId: { text: "Nombre", value: "pkId" },
      TXTipoPrecioId: { text: "Nombre", value: "pkId" },
      TXCanalVentasId: { text: "Nombre", value: "pkId" },
      TXAlojamientoId: { text: "Nombre", value: "pkId" },
    };
    const cfg = mapConfig[controlName];
    if (!cfg) return null;

    const found = list.find(
      (x) => this.normalizeListLabel(x?.[cfg.text]) === txt
    );
    if (!found) return null;
    return this.parseIncomingInputFilterValue(found?.[cfg.value]);
  }

  private skipProductoResolveFromVisible(controlName: string, vis: any): boolean {
    if (controlName !== "ProductoId") {
      return false;
    }
    const t = this.normalizeListLabel(vis);
    if (!t) {
      return false;
    }
    const ph = this.normalizeListLabel(this.productoPlaceholder);
    return ph !== "" && t === ph;
  }

  syncInputFilterFromChild(
    ev: { name: string; value: any; methods?: any },
    fromBlurClose = false
  ): void {
    if (!ev?.name) return;
    const ctrl = this.editForm.get(ev.name);
    if (!ctrl) return;
    let value = this.resolveInputFilterValueFromMethods(ev);
    if (value === null) {
      value = this.parseIncomingInputFilterValue(ev.value);
    }
    if (value === null && typeof ev.methods?.getAnswerVisibleForSync === "function") {
      const vis = ev.methods.getAnswerVisibleForSync();
      if (
        !this.valorVacio(vis) &&
        !this.skipProductoResolveFromVisible(ev.name, vis)
      ) {
        value = this.resolveValueByVisibleText(ev.name, vis);
      }
    }
    ctrl.setValue(value);
    ctrl.markAsTouched();
    ctrl.updateValueAndValidity({ emitEvent: true });
    if (
      !fromBlurClose &&
      ev.name === "ProductoId" &&
      this.isProductoIdValorValido(ctrl.value) &&
      this.isProductoIdInOptionsList(ctrl.value)
    ) {
      this.productoSubmitRequiredLatch = false;
    }
  }

  syncInputFilterFromClose(ev: { name: string; value: any; methods?: any }): void {
    if (!ev?.name) return;
    const ctrl = this.editForm.get(ev.name);
    if (!ctrl) return;

    let incoming = this.resolveInputFilterValueFromMethods(ev);
    if (incoming === null) {
      incoming = this.parseIncomingInputFilterValue(ev.value);
    }
    if (incoming === null && typeof ev.methods?.getAnswerVisibleForSync === "function") {
      const vis = ev.methods.getAnswerVisibleForSync();
      if (
        !this.valorVacio(vis) &&
        !this.skipProductoResolveFromVisible(ev.name, vis)
      ) {
        incoming = this.resolveValueByVisibleText(ev.name, vis);
      }
    }

    const current = ctrl.value;
    const incomingEmpty =
      incoming === undefined || incoming === null;
    const currentHasValue =
      current !== null && current !== undefined && String(current).trim() !== "";

    if (incomingEmpty && currentHasValue) {
      return;
    }

    this.syncInputFilterFromChild({ ...ev, value: incoming }, true);
  }

  private registerWatchers(): void {
    this.editForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.panelService.setDiscardChanges(false);
    });

    this.editForm
      .get("TipoProducto")
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(async (tipo) => {
        if (this.suppressProductoTaxonomiaApply) {
          return;
        }
        await this.onTipoProductoChanged(tipo);
      });

    this.editForm
      .get("ProductoId")
      ?.valueChanges.pipe(
        takeUntil(this.destroy$),
        debounceTime(120),
        distinctUntilChanged(
          (a, b) => String(a ?? "") === String(b ?? "")
        ),
        switchMap((productoId) =>
          from(this.applyTaxonomiaFromEntradaIfNeeded(productoId)).pipe(
            catchError(() => of(undefined))
          )
        )
      )
      .subscribe();
  }

  private async loadInitialData(): Promise<void> {
    try {
      await Promise.all([
        this.cargarTaxonomiaCombos(),
        this.cargarNivelTaxonomia(1, ""),
      ]);

      if (this.pkId && this.mode !== "I") {
        await this.loadEditionData();
      } else {
        this.loading = false;
        this.captureDiscardSnapshot();
        this.panelService.setDiscardChanges(true);
      }
    } catch (error) {
      this.loading = false;
      this.httpErrorService.identificarErrores(error);
    }
  }

  private pickItemFromTxResponse(
    resp: any,
    opts?: { pkId?: number; productoId?: number; tipoProducto?: number }
  ): any {
    const d = resp?.DatosResult;
    if (!d) return null;
    const list = Array.isArray(d.Lista)
      ? d.Lista
      : Array.isArray(d.Listado)
      ? d.Listado
      : null;
    if (list?.length) {
      const wantPk = opts?.pkId;
      const wantProd = opts?.productoId;
      const wantTipo = opts?.tipoProducto;
      if (
        wantPk != null &&
        Number.isFinite(wantPk) &&
        wantPk > 0 &&
        wantProd != null &&
        Number.isFinite(wantProd) &&
        wantProd > 0 &&
        wantTipo != null &&
        Number.isFinite(wantTipo) &&
        wantTipo > 0
      ) {
        const match = list.find((x) => {
          const pkOk =
            Number(x?.pkId) === wantPk || String(x?.pkId) === String(wantPk);
          const tipoRaw = x?.TipoProductoId ?? x?.TipoProducto;
          const tipoNum = Number(tipoRaw);
          return (
            pkOk &&
            Number(x?.ProductoId) === wantProd &&
            Number.isFinite(tipoNum) &&
            tipoNum === wantTipo
          );
        });
        if (match) {
          return match;
        }
      }
      if (wantPk != null && Number.isFinite(wantPk) && wantPk > 0) {
        const match = list.find(
          (x) =>
            Number(x?.pkId) === wantPk || String(x?.pkId) === String(wantPk)
        );
        if (match) {
          return match;
        }
      }
      if (
        wantProd != null &&
        Number.isFinite(wantProd) &&
        wantProd > 0 &&
        wantTipo != null &&
        Number.isFinite(wantTipo) &&
        wantTipo > 0
      ) {
        const match = list.find((x) => {
          const tipoRaw = x?.TipoProductoId ?? x?.TipoProducto;
          return (
            Number(x?.ProductoId) === wantProd &&
            Number(tipoRaw) === wantTipo
          );
        });
        if (match) {
          return match;
        }
      }
      return list[0];
    }
    if (d.TipoProducto != null || d.ProductoId != null || d.pkId != null) {
      return d;
    }
    return null;
  }

  private async loadEditionData(): Promise<void> {
    const ctx = this.otherProps || {};
    const tipoCtx = this.resolveTipoProductoNumFromItem(ctx);
    const prodCtx = Number(ctx.ProductoId ?? 0);
    const pk = Number(this.pkId ?? ctx.pkId ?? 0);

    let response: any;
    let item: any = null;

    const filtersCargaUnica: any[] = [];
    if (tipoCtx > 0) {
      filtersCargaUnica.push({
        filterApi: "TipoProducto",
        name: "TipoProducto",
        value: String(tipoCtx),
        show: "",
        translation: "",
        db: "",
      });
    }
    if (prodCtx > 0) {
      filtersCargaUnica.push({
        filterApi: "ProductoId",
        name: "ProductoId",
        value: String(prodCtx),
        show: "",
        translation: "",
        db: "",
      });
    }

    if (pk > 0) {
      response = await this.servicioAPI.getProductoTaxonomiaAsync(
        null,
        filtersCargaUnica.length ? filtersCargaUnica : null,
        pk,
        tipoCtx > 0 ? tipoCtx : undefined,
        prodCtx > 0 ? prodCtx : undefined
      );
      item = this.pickItemFromTxResponse(response, {
        pkId: pk,
        productoId: prodCtx > 0 ? prodCtx : undefined,
        tipoProducto: tipoCtx > 0 ? tipoCtx : undefined,
      });
    }

    if (!item && tipoCtx > 0 && prodCtx > 0) {
      response = await this.servicioAPI.getProductoTaxonomiaAsync(null, [
        {
          filterApi: "TipoProducto",
          name: "TipoProducto",
          value: String(tipoCtx),
          show: "",
          translation: "",
          db: "",
        } as any,
        {
          filterApi: "ProductoId",
          name: "ProductoId",
          value: String(prodCtx),
          show: "",
          translation: "",
          db: "",
        } as any,
      ]);
      item = this.pickItemFromTxResponse(response, {
        productoId: prodCtx,
        tipoProducto: tipoCtx,
      });
    }

    if (!item) {
      this.loading = false;
      this.snackbar.openSnackBar(
        this.translation?.E ||
          this.translation?.NoSeHanEncontradoDatos ||
          "No se han encontrado datos",
        "",
        "red-snackbar"
      );
      return;
    }
    this.suppressProductoTaxonomiaApply = true;
    try {
      const duplicated = this.mode === "D";
      const tipoProductoNum = this.resolveTipoProductoNumFromItem(item);
      this.editForm.patchValue({
        pkId: duplicated ? 0 : +(item.pkId || 0),
        TipoProducto: tipoProductoNum || null,
        ProductoId: +(item.ProductoId || 0),
        TXCentroCosteId: +(item.TXCentroCosteId || 0),
        TXTipoPrecioId: +(item.TXTipoPrecioId || 0),
        TXCanalVentasId: +(item.TXCanalVentasId || 0),
        TXAlojamientoId: +(item.TXAlojamientoId || 0),
        TXItemVentasId: +(item.TXItemVentasId || 0),
      });
      this.loadedTipoNombre = this.tipoNombrePorValor(tipoProductoNum);
      this.loadedProductoNombre = String(item.ProductoNombre || "");
      if (duplicated) {
        this.itemVentaTxDuplicateProductoFlow = true;
      }
      await this.onTipoProductoChanged(tipoProductoNum, false);
      for (let n = 1; n <= 7; n++) {
        this.editForm.patchValue({ [`Nivel${n}`]: null }, { emitEvent: false });
      }
      for (let n = 2; n <= 7; n++) {
        this.txNiveles[n] = [];
        this.actualizarValidadorNivel(n, false);
      }
      await this.cargarNivelTaxonomia(1, "");
      await this.setNivelesFromItem(item);
      this.applyProductoTaxonomiaSinNombresNivel(item);
      this.inputFilterUiSyncKey++;
      if (duplicated) {
        const dupPid = +(item.ProductoId || 0);
        this.itemVentaTxDuplicateLastProductoIdSinModal =
          Number.isFinite(dupPid) && dupPid > 0 ? dupPid : null;
        this.mode = "I";
      }
    } finally {
      this.suppressProductoTaxonomiaApply = false;
    }
    this.loading = false;
    this.captureDiscardSnapshot();
    this.panelService.setDiscardChanges(true);
    this.cdRef.detectChanges();
  }

  private makeSyntheticNivelNode(
    nombre: string,
    item: any,
    level: number
  ): any {
    const name = String(nombre ?? "").trim();
    let tieneSucesor = false;
    for (let k = level + 1; k <= 7; k++) {
      const v = item[`TXNivel${k}`];
      if (v != null && String(v).trim() !== "") {
        tieneSucesor = true;
        break;
      }
    }
    const isLeaf = !tieneSucesor;
    return {
      NivelNombre: name,
      TieneSucesor: isLeaf ? 0 : 1,
      pkId: 0,
      TXItemVentasId: isLeaf ? item.TXItemVentasId : undefined,
      RevenueCategory: isLeaf ? item.TXRevenueCategory : undefined,
      CuentaVisitante: isLeaf ? item.TXCuentaVisitante : undefined,
    };
  }

  private ensureNivelOptionSelected(
    nivel: number,
    item: any,
    nombreEsperado: string
  ): any {
    const trimmed = String(nombreEsperado ?? "").trim();
    if (!trimmed) {
      return null;
    }
    let found =
      this.txNiveles[nivel]?.find((x) => x.NivelNombre === trimmed) || null;
    if (!found) {
      found = this.makeSyntheticNivelNode(trimmed, item, nivel);
      const base = [...(this.txNiveles[nivel] || [])];
      if (!base.some((x) => x.NivelNombre === trimmed)) {
        base.push(found);
      }
      this.txNiveles[nivel] = base;
    }
    if (nivel > 1) {
      this.actualizarValidadorNivel(
        nivel,
        (this.txNiveles[nivel] || []).length > 0
      );
    }
    return found;
  }

  private async setNivelesFromItem(
    item: any,
    isStale?: () => boolean
  ): Promise<void> {
    const nivel1Str =
      item.TXNivel1 != null ? String(item.TXNivel1).trim() : "";
    if (!nivel1Str) {
      return;
    }

    this.editForm.patchValue({ TXItemVentasId: null }, { emitEvent: false });
    this.revenueCategoryInfo = "";
    this.clearCuentaVisitanteInfo();
    this.hasRevenueCategoryValue = false;
    this.hasCuentaVisitanteValue = false;
    this.ultimoNivelLeaf = null;

    const n1 = this.ensureNivelOptionSelected(1, item, nivel1Str);
    if (!n1) {
      return;
    }
    this.editForm.patchValue({ Nivel1: n1 }, { emitEvent: false });
    let current = n1;
    for (let nivel = 2; nivel <= 7; nivel++) {
      const key = `TXNivel${nivel}`;
      const raw = item[key];
      if (!raw || String(raw).trim() === "" || !current) {
        break;
      }
      await this.cargarNivelTaxonomia(nivel, current.NivelNombre);
      if (isStale?.()) {
        return;
      }
      const found = this.ensureNivelOptionSelected(nivel, item, String(raw));
      if (!found) {
        break;
      }
      this.editForm.patchValue({ [`Nivel${nivel}`]: found }, { emitEvent: false });
      current = found;
    }
    if (current && (current.TieneSucesor === 0 || current.TieneSucesor === "0")) {
      this.applyLeafData(current);
    }

    this.applyTxRowMetadataFromItem(item);
  }

  private applyTxRowMetadataFromItem(item: any): void {
    const rawCuenta = item?.TXCuentaVisitante;
    const cuentaNum = Number(rawCuenta);
    const cuentaValida =
      rawCuenta !== null &&
      rawCuenta !== undefined &&
      String(rawCuenta).trim() !== "" &&
      !Number.isNaN(cuentaNum) &&
      cuentaNum >= 0 &&
      cuentaNum <= 1;
    if (cuentaValida) {
      this.hasCuentaVisitanteValue = true;
      this.assignCuentaVisitanteInfo(rawCuenta);
    }
    const rev = item?.TXRevenueCategory;
    const revStr = rev != null ? String(rev).trim() : "";
    if (revStr && revStr !== "-" && revStr !== " - ") {
      this.hasRevenueCategoryValue = true;
      this.revenueCategoryInfo = revStr;
    }
  }

  private applyProductoTaxonomiaSinNombresNivel(item: any): void {
    const nivel1Str =
      item.TXNivel1 != null ? String(item.TXNivel1).trim() : "";
    if (nivel1Str) {
      return;
    }
    const tieneTx = String(item.TieneTX ?? "0") === "1";
    const txItem = Number(item.TXItemVentasId || 0);
    if (!tieneTx && !(txItem > 0)) {
      this.applyTxRowMetadataFromItem(item);
      return;
    }
    if (txItem > 0) {
      this.editForm.patchValue({ TXItemVentasId: txItem }, { emitEvent: false });
    }
    const rev = item.TXRevenueCategory;
    const revStr = rev != null ? String(rev).trim() : "";
    if (revStr && revStr !== "-" && revStr !== " - ") {
      this.hasRevenueCategoryValue = true;
      this.revenueCategoryInfo = revStr;
    }
    const rawCuenta = item.TXCuentaVisitante;
    const cuentaNum = Number(rawCuenta);
    this.hasCuentaVisitanteValue =
      rawCuenta !== null &&
      rawCuenta !== undefined &&
      String(rawCuenta).trim() !== "" &&
      !Number.isNaN(cuentaNum) &&
      cuentaNum > -1;
    this.assignCuentaVisitanteInfo(rawCuenta);
  }

  async onTipoProductoChanged(
    tipo: number | string,
    resetProducto = true
  ): Promise<void> {
    if (!tipo) {
      this.productosOptions = [];
      this.productoSubmitRequiredLatch = false;
      return;
    }
    await this.cargarProductosByTipo(+tipo);
    if (resetProducto) {
      this.editForm.patchValue({ ProductoId: null });
      this.productoSubmitRequiredLatch = false;
    }
    if (Number(tipo) !== 1) {
      this.editForm.patchValue({ TXAlojamientoId: 0 });
    }
  }

  private entradaProductoRowHasTaxonomiaUtil(t: any): boolean {
    if (!t || typeof t !== "object") {
      return false;
    }
    const nPos = (v: any): boolean => {
      const x = Number(v);
      return Number.isFinite(x) && x > 0;
    };
    if (
      nPos(t.TXCentroCosteId) ||
      nPos(t.TXTipoPrecioId) ||
      nPos(t.TXCanalVentasId) ||
      nPos(t.TXAlojamientoId)
    ) {
      return true;
    }
    if (String(t.TXNivel1 ?? "").trim() !== "") {
      return true;
    }
    if (nPos(t.TXItemVentasId)) {
      return true;
    }
    const rev = t.RevenueCategory;
    const revStr = rev != null ? String(rev).trim() : "";
    if (revStr && revStr !== "-" && revStr !== " - ") {
      return true;
    }
    const rawCuenta = t.CuentaVisitante;
    const cuentaNum = Number(rawCuenta);
    if (
      rawCuenta !== null &&
      rawCuenta !== undefined &&
      String(rawCuenta).trim() !== "" &&
      !Number.isNaN(cuentaNum) &&
      cuentaNum > -1
    ) {
      return true;
    }
    return false;
  }

  private async clearEntradaTaxonomiaWhenProductoHasNoTaxonomia(): Promise<void> {
    const seq = ++this.taxonomiaEntradaApplySeq;
    const isStale = () => seq !== this.taxonomiaEntradaApplySeq;

    this.editForm.patchValue(
      {
        TXCentroCosteId: null,
        TXTipoPrecioId: null,
        TXCanalVentasId: null,
        TXAlojamientoId: 0,
        TXItemVentasId: null,
        Nivel1: null,
        Nivel2: null,
        Nivel3: null,
        Nivel4: null,
        Nivel5: null,
        Nivel6: null,
        Nivel7: null,
      },
      { emitEvent: false }
    );
    for (let n = 2; n <= 7; n++) {
      this.txNiveles[n] = [];
      this.actualizarValidadorNivel(n, false);
    }
    this.txNiveles[1] = [];
    this.revenueCategoryInfo = "";
    this.clearCuentaVisitanteInfo();
    this.hasRevenueCategoryValue = false;
    this.hasCuentaVisitanteValue = false;
    this.ultimoNivelLeaf = null;

    await this.cargarNivelTaxonomia(1, "");
    if (isStale()) {
      return;
    }
    this.inputFilterUiSyncKey++;
    this.cdRef.detectChanges();
  }

  private async applyTaxonomiaFromEntradaIfNeeded(productoId: any): Promise<void> {
    if (this.suppressProductoTaxonomiaApply) {
      return;
    }
    if (Number(this.editForm.get("TipoProducto")?.value) !== 1) {
      return;
    }
    if (productoId === null || productoId === undefined || productoId === "") {
      return;
    }
    const pid = Number(productoId);
    if (!Number.isFinite(pid) || pid <= 0) {
      return;
    }
    const row = this.productosOptions.find(
      (x) => Number(x.pkId) === pid || String(x.pkId) === String(pid)
    );
    if (!row) {
      return;
    }
    const t = row.Taxonomia;
    if (!this.entradaProductoRowHasTaxonomiaUtil(t)) {
      if (this.itemVentaTxDuplicateProductoFlow) {
        /* Duplicar: manter combos/niveis/categoría copiados da fila; só mudou o nome produto na lista. */
        if (Number.isFinite(pid) && pid > 0) {
          this.itemVentaTxDuplicateLastProductoIdSinModal = pid;
        }
      } else {
        await this.clearEntradaTaxonomiaWhenProductoHasNoTaxonomia();
      }
      return;
    }

    if (this.shouldConfirmDuplicateProductoConTaxonomia(pid)) {
      const confirmed = await this.confirmDuplicateProductoConTaxonomiaExistente();
      if (!confirmed) {
        this.revertDuplicateProductoSelectionAfterDialogCancel();
        return;
      }
    }

    const seq = ++this.taxonomiaEntradaApplySeq;
    const isStale = () => seq !== this.taxonomiaEntradaApplySeq;

    const numPos = (v: any): number | undefined => {
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? n : undefined;
    };

    const patch: Record<string, number | null> = {};
    const cc = numPos(t.TXCentroCosteId);
    const tp = numPos(t.TXTipoPrecioId);
    const cv = numPos(t.TXCanalVentasId);
    const al = numPos(t.TXAlojamientoId);
    if (cc !== undefined) {
      patch.TXCentroCosteId = cc;
    }
    if (tp !== undefined) {
      patch.TXTipoPrecioId = tp;
    }
    if (cv !== undefined) {
      patch.TXCanalVentasId = cv;
    }
    if (al !== undefined) {
      patch.TXAlojamientoId = al;
    }

    for (let n = 1; n <= 7; n++) {
      this.editForm.patchValue({ [`Nivel${n}`]: null }, { emitEvent: false });
      if (n > 1) {
        this.txNiveles[n] = [];
        this.actualizarValidadorNivel(n, false);
      }
    }
    this.revenueCategoryInfo = "";
    this.clearCuentaVisitanteInfo();
    this.hasRevenueCategoryValue = false;
    this.hasCuentaVisitanteValue = false;
    this.ultimoNivelLeaf = null;
    this.editForm.patchValue({ TXItemVentasId: null }, { emitEvent: false });

    if (Object.keys(patch).length) {
      this.editForm.patchValue(patch, { emitEvent: false });
    }

    await this.cargarNivelTaxonomia(1, "");
    if (isStale()) {
      return;
    }

    const nivel1Name = String(t.TXNivel1 ?? "").trim();
    if (nivel1Name) {
      await this.setNivelesFromItem(t, isStale);
      if (isStale()) {
        return;
      }
    } else {
      const txItem = Number(t.TXItemVentasId || 0);
      if (txItem > 0) {
        this.editForm.patchValue({ TXItemVentasId: txItem }, { emitEvent: false });
      }
      const rev = t.RevenueCategory;
      const revStr = rev != null ? String(rev).trim() : "";
      if (revStr && revStr !== "-") {
        this.hasRevenueCategoryValue = true;
        this.revenueCategoryInfo = revStr;
      }
      const rawCuenta = t.CuentaVisitante;
      const cuentaNum = Number(rawCuenta);
      this.hasCuentaVisitanteValue =
        rawCuenta !== null &&
        rawCuenta !== undefined &&
        String(rawCuenta).trim() !== "" &&
        !Number.isNaN(cuentaNum) &&
        cuentaNum > -1;
      this.assignCuentaVisitanteInfo(rawCuenta);
    }

    if (isStale()) {
      return;
    }
    if (this.itemVentaTxDuplicateProductoFlow) {
      this.itemVentaTxDuplicateLastProductoIdSinModal = pid;
    }
    this.inputFilterUiSyncKey++;
    this.cdRef.detectChanges();
  }

  private shouldConfirmDuplicateProductoConTaxonomia(pid: number): boolean {
    return (
      this.itemVentaTxDuplicateProductoFlow &&
      this.itemVentaTxDuplicateLastProductoIdSinModal != null &&
      pid !== this.itemVentaTxDuplicateLastProductoIdSinModal
    );
  }

  private revertDuplicateProductoSelectionAfterDialogCancel(): void {
    this.taxonomiaEntradaApplySeq++;
    this.suppressProductoTaxonomiaApply = true;
    try {
      const prev = this.itemVentaTxDuplicateLastProductoIdSinModal;
      if (prev != null) {
        this.editForm.patchValue({ ProductoId: prev }, { emitEvent: false });
      }
      this.inputFilterUiSyncKey++;
    } finally {
      this.suppressProductoTaxonomiaApply = false;
    }
    this.cdRef.detectChanges();
  }

  private async confirmDuplicateProductoConTaxonomiaExistente(): Promise<boolean> {
    const tr = this.translation || {};
    const dialogRef = this.dialog.open(DialogoPopUp, {
      width: "250px",
      data: {
        titulo:
          tr.ItemVentaTX_DuplicarProductoTaxonomiaTitulo ??
          tr.NombreProducto ??
          "Nombre producto",
        texto:
          tr.ItemVentaTX_DuplicarProductoTaxonomiaTexto ??
          "Este nombre de producto ya está asociado a una taxonomía. Los datos serán alterados.",
        eleccion: tr.Patatas ?? "",
        ok: tr.Confirmar ?? "Confirmar",
        ko: tr.Cancelar ?? "Cancelar",
      },
    });
    const result = await dialogRef
      .afterClosed()
      .pipe(take(1))
      .toPromise();
    return result === "SI";
  }

  async onNivelTaxonomiaChange(nivel: number): Promise<void> {
    for (let n = nivel + 1; n <= 7; n++) {
      this.editForm.patchValue({ [`Nivel${n}`]: null }, { emitEvent: false });
      this.txNiveles[n] = [];
      this.actualizarValidadorNivel(n, false);
    }

    this.revenueCategoryInfo = "";
    this.clearCuentaVisitanteInfo();
    this.hasRevenueCategoryValue = false;
    this.hasCuentaVisitanteValue = false;
    this.ultimoNivelLeaf = null;
    this.editForm.patchValue({ TXItemVentasId: null }, { emitEvent: false });

    const selected = this.editForm.get(`Nivel${nivel}`)?.value;
    if (!selected) return;

    if (selected.TieneSucesor === 0 || selected.TieneSucesor === "0") {
      this.applyLeafData(selected);
      return;
    }
    const nextLevel = nivel + 1;
    if (nextLevel <= 7) {
      await this.cargarNivelTaxonomia(nextLevel, selected.NivelNombre);
    }
  }

  private applyLeafData(item: any): void {
    this.ultimoNivelLeaf = item;
    const rawRevenue = item?.RevenueCategory;
    this.hasRevenueCategoryValue =
      rawRevenue !== null &&
      rawRevenue !== undefined &&
      String(rawRevenue).trim() !== "";
    this.revenueCategoryInfo = this.hasRevenueCategoryValue
      ? String(rawRevenue)
      : "";
    const rawCuenta = item?.CuentaVisitante;
    const cuentaNum = Number(rawCuenta);
    this.hasCuentaVisitanteValue =
      rawCuenta !== null &&
      rawCuenta !== undefined &&
      String(rawCuenta).trim() !== "" &&
      !Number.isNaN(cuentaNum) &&
      cuentaNum > -1;
    this.assignCuentaVisitanteInfo(rawCuenta);
    this.editForm.patchValue(
      { TXItemVentasId: +(item.TXItemVentasId || item.pkId || 0) },
      { emitEvent: false }
    );
  }

  private textoCuentaVisitante(raw: any): string {
    if (raw === null || raw === undefined || String(raw).trim() === "") {
      return "";
    }
    const n = Number(raw);
    if (!Number.isNaN(n) && n < 0) return "";
    const t = this.translator.GetTranslations() || this.translation || {};
    if (n === 1) return t.Si ?? "Si";
    if (n === 0) return t.No ?? "No";
    return String(raw);
  }

  private resolveTipoProductoNumFromItem(item: any): number {
    const idOnly = Number(item?.TipoProductoId ?? 0);
    if (Number.isFinite(idOnly) && idOnly >= 1 && idOnly <= 3) {
      return idOnly;
    }
    const raw = item?.TipoProducto;
    let n = Number(raw);
    if (Number.isFinite(n) && n >= 1 && n <= 3) {
      return n;
    }
    const s = String(raw ?? "").trim();
    if (s === "1" || s === "2" || s === "3") {
      return Number(s);
    }
    const tr = this.translation || {};
    const ent = String(tr.TipoProductoEntrada ?? "Entrada").trim();
    const pro = String(tr.TipoProductoPromocion ?? "Promoción").trim();
    const tab = String(tr.TipoProductoTAbonado ?? "T Abonado").trim();
    if (s === ent || s === "Entrada") {
      return 1;
    }
    if (s === pro || s === "Promoción" || s === "Promocion") {
      return 2;
    }
    if (s === tab || s === "T Abonado") {
      return 3;
    }
    return 0;
  }

  private tipoNombrePorValor(tipo: number): string {
    if (tipo === 1) return this.translation?.TipoProductoEntrada ?? "Entrada";
    if (tipo === 2) return this.translation?.TipoProductoPromocion ?? "Promoción";
    if (tipo === 3) return this.translation?.TipoProductoTAbonado ?? "T Abonado";
    return "";
  }

  private actualizarValidadorNivel(nivel: number, required: boolean): void {
    const ctrl = this.editForm.get(`Nivel${nivel}`);
    if (!ctrl) return;
    if (required) {
      ctrl.setValidators([Validators.required]);
    } else {
      ctrl.clearValidators();
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private valorVacio(value: any): boolean {
    return value === null || value === undefined || String(value).trim() === "";
  }

  private idRequeridoVacio(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }
    const s = String(value).trim();
    if (s === "") {
      return true;
    }
    const n = Number(value);
    if (Number.isNaN(n) || !Number.isFinite(n) || n <= 0) {
      return true;
    }
    return false;
  }

  private touchControl(controlName: string): void {
    const ctrl = this.editForm.get(controlName);
    if (!ctrl) return;
    ctrl.markAsTouched();
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private labelByControl(controlName: string): string {
    const fallback: Record<string, string> = {
      TipoProducto: "Tipo",
      ProductoId: "Nombre producto",
      TXCentroCosteId: "Centro coste TX",
      TXTipoPrecioId: "Tipo precio TX",
      TXCanalVentasId: "Canal ventas TX",
      TXAlojamientoId: "Alojamiento TX",
      Nivel1: "Nivel 1 TX",
      Nivel2: "Nivel 2 TX",
      Nivel3: "Nivel 3 TX",
      Nivel4: "Nivel 4 TX",
      Nivel5: "Nivel 5 TX",
      Nivel6: "Nivel 6 TX",
      Nivel7: "Nivel 7 TX",
    };
    const m = /^Nivel(\d+)$/.exec(controlName);
    if (m) {
      const n = Number(m[1]);
      return this.nivelTxMatLabel(n);
    }
    const t = this.translator.GetTranslations() || this.translation || {};
    const fromTranslations: Record<string, string> = {
      TipoProducto: this.translation?.Tipo,
      ProductoId: this.translation?.NombreProducto,
      TXCentroCosteId: txTaxonomyFieldLabel(t, "CentroCoste", "Centro coste"),
      TXTipoPrecioId: txTaxonomyFieldLabel(t, "TipoPrecio", "Tipo precio"),
      TXCanalVentasId: txTaxonomyFieldLabel(t, "CanalVentas", "Canal ventas"),
      TXAlojamientoId: txTaxonomyFieldLabel(t, "Alojamiento", "Alojamiento"),
    };
    return fromTranslations[controlName] || fallback[controlName] || controlName;
  }

  private nivelTieneSucesor(nivel: any): boolean {
    if (!nivel) return false;
    return nivel.TieneSucesor === 1 || nivel.TieneSucesor === "1";
  }

  private txItemIdFromNode(node: any): number {
    if (!node) return 0;
    const raw = node.TXItemVentasId ?? node.pkId;
    const id = Number(raw);
    return Number.isFinite(id) && id > 0 ? id : 0;
  }

  private relaxProductHeaderValidatorsForModify(): void {
    const tipo = this.editForm.get("TipoProducto");
    const prod = this.editForm.get("ProductoId");
    tipo?.clearValidators();
    prod?.clearValidators();
    tipo?.updateValueAndValidity({ emitEvent: false });
    prod?.updateValueAndValidity({ emitEvent: false });
  }

  private resolveSubmitValidation(): { ok: boolean; message?: string; txItemVentasId?: number } {
    const requiredHeaderControls: string[] = [
      ...(this.isUpdateMode ? [] : ["TipoProducto", "ProductoId"]),
      "TXCentroCosteId",
      "TXTipoPrecioId",
      "TXCanalVentasId",
    ];

    for (const controlName of requiredHeaderControls) {
      const value = this.editForm.get(controlName)?.value;
      if (this.idRequeridoVacio(value)) {
        this.touchControl(controlName);
        return {
          ok: false,
          message: `${this.translation?.CampoRequerido || "Campo requerido"}: ${this.labelByControl(controlName)}`,
        };
      }
    }

    const nivel1 = this.editForm.get("Nivel1")?.value;
    if (!nivel1) {
      this.touchControl("Nivel1");
      return {
        ok: false,
        message: `${this.translation?.CampoRequerido || "Campo requerido"}: ${this.labelByControl("Nivel1")}`,
      };
    }

    let current = nivel1;
    let leafNode = this.nivelTieneSucesor(current) ? null : current;

    for (let nivel = 1; nivel < 7; nivel++) {
      if (!current) break;
      if (!this.nivelTieneSucesor(current)) {
        leafNode = current;
        break;
      }

      const nextLevel = nivel + 1;
      const nextOptions = this.txNiveles[nextLevel] || [];
      const nextValue = this.editForm.get(`Nivel${nextLevel}`)?.value;

      if (nextOptions.length > 0 && !nextValue) {
        this.touchControl(`Nivel${nextLevel}`);
        return {
          ok: false,
          message: `${this.translation?.CampoRequerido || "Campo requerido"}: ${this.labelByControl(`Nivel${nextLevel}`)}`,
        };
      }

      if (!nextOptions.length) {
        leafNode = current;
        break;
      }

      current = nextValue;
      if (current && !this.nivelTieneSucesor(current)) {
        leafNode = current;
        break;
      }
    }

    const txItemFromLeaf = this.txItemIdFromNode(leafNode);
    const txItemFromForm = Number(this.editForm.get("TXItemVentasId")?.value || 0);
    const txItemVentasId = txItemFromLeaf || txItemFromForm;
    if (!txItemVentasId) {
      return {
        ok: false,
        message:
          this.translation?.CompleteNivelTX ||
          this.translation?.FaltanCamposObligatorios ||
          "Complete la cadena de niveles TX hasta un nivel final.",
      };
    }

    return { ok: true, txItemVentasId };
  }

  private normalizeOptionList(
    items: any[],
    textKeys: string[] = ["Nombre"],
    valueKeys: string[] = ["pkId", "PkId", "Id", "id"]
  ): any[] {
    return (items || []).map((x: any) => {
      let normalizedValue: any = "";
      for (const k of valueKeys) {
        if (x?.[k] !== undefined && x?.[k] !== null && String(x?.[k]).trim() !== "") {
          normalizedValue = x[k];
          break;
        }
      }

      let normalizedName = "";
      for (const k of textKeys) {
        if (x?.[k] !== undefined && x?.[k] !== null && String(x?.[k]).trim() !== "") {
          normalizedName = String(x[k]);
          break;
        }
      }

      return {
        ...x,
        pkId: this.coerceNumericId(normalizedValue),
        Nombre: normalizedName,
      };
    });
  }

  private async cargarTaxonomiaCombos(): Promise<void> {
    const [centroCoste, tipoPrecio, canalVentas, alojamiento] = await Promise.all([
      this.servicioAPI.TraerDatosListasAsync("txcentrocoste" as any).toPromise(),
      this.servicioAPI.TraerDatosListasAsync("txtipoprecio" as any).toPromise(),
      this.servicioAPI
        .TraerDatosListasAsync("txcanalventa" as any, {
          NombreCampo: "activo" as any,
          FiltroCampo: "1",
        } as any)
        .toPromise(),
      this.servicioAPI.TraerDatosListasAsync("txalojamiento" as any).toPromise(),
    ]);
    this.txCentroCosteOptions = this.normalizeOptionList(
      centroCoste?.DatosListas ?? [],
      ["Nombre", "chCentroCosteTX"]
    );
    this.txTipoPrecioOptions = this.normalizeOptionList(
      tipoPrecio?.DatosListas ?? [],
      ["Nombre", "chTipoPrecioTX"]
    );
    this.txCanalVentasOptions = this.normalizeOptionList(
      canalVentas?.DatosListas ?? [],
      ["Nombre", "chCanalVentasTX"]
    );
    this.txAlojamientoOptions = this.normalizeOptionList(
      alojamiento?.DatosListas ?? [],
      ["Nombre", "chCodAlojamientoTX"]
    );
  }

  /**
   * Duplicar asociación (Entrada): GetProductoTaxonomia solo con filtro TieneTX=0 (como contrato API);
   * en cliente se dejan filas con tipo Entrada (TipoProductoId / TipoProducto = 1).
   * El producto origen del duplicado suele tener TX; se añade a la lista si falta para poder mostrarlo seleccionado.
   */
  private shouldLoadEntradaProductosSinTaxonomia(): boolean {
    return this.mode === "D" || this.itemVentaTxDuplicateProductoFlow === true;
  }

  private mergeEntradaProductoDuplicadoSiFalta(options: any[]): any[] {
    if (!this.shouldLoadEntradaProductosSinTaxonomia()) {
      return options;
    }
    const pid = Number(this.editForm?.get("ProductoId")?.value);
    if (!Number.isFinite(pid) || pid <= 0) {
      return options;
    }
    const has = options.some(
      (o) =>
        Number(this.coerceNumericId(o?.pkId ?? o?.ProductoId ?? o?.Id)) === pid
    );
    if (has) {
      return options;
    }
    const nombre =
      String(this.loadedProductoNombre || "").trim() ||
      this.translation?.NombreProducto ||
      `ID ${pid}`;
    return [
      ...options,
      {
        pkId: pid,
        ProductoId: pid,
        Nombre: nombre,
        ProductoNombre: nombre,
      },
    ];
  }

  private async cargarProductosByTipo(tipo: number): Promise<void> {
    try {
      if (tipo === 1) {
        if (this.shouldLoadEntradaProductosSinTaxonomia()) {
          const paginator = new Paginator(1, 5000, "ProductoNombre", "ASC");
          const filters: any[] = [
            {
              filterApi: "TieneTX",
              name: "TieneTX",
              value: "0",
              show: "",
              translation: "",
              db: "",
            },
          ];
          const response = await this.servicioAPI.getProductoTaxonomiaAsync(
            paginator,
            filters
          );
          const listaRaw =
            response?.DatosResult?.Lista ?? response?.DatosResult?.Listado ?? [];
          const lista = (listaRaw || []).filter((row: any) => {
            const t = row?.TipoProductoId ?? row?.TipoProducto;
            const n = Number(t);
            return n === 1 || String(t ?? "").trim() === "1";
          });
          this.productosOptions = this.mergeEntradaProductoDuplicadoSiFalta(
            this.normalizeOptionList(
              lista,
              ["ProductoNombre", "Nombre", "chNombre"],
              ["ProductoId", "pkId", "Id", "EntradaId"]
            )
          );
          return;
        }
        const data = await this.servicioAPI.GetTipoEntradaLegacy().toPromise();
        this.productosOptions = this.normalizeOptionList(
          data?.DatosResult?.Lista ?? [],
          ["Nombre", "chNombre", "NombreTipo"],
          ["pkId", "EntradaId", "Id"]
        );
        return;
      }
      if (tipo === 2) {
        const data = await this.servicioAPI.getTiposBonosMs().toPromise();
        this.productosOptions = this.normalizeOptionList(
          data?.DatosResult?.lista ?? [],
          ["Nombre", "nombre", "chNombrePromo"],
          ["pkId", "Id", "id"]
        );
        return;
      }
      const data = await this.servicioAPI
        .TraerDatosListasAsync("tipoabonado" as any)
        .toPromise();
      this.productosOptions = this.normalizeOptionList(
        data?.DatosListas ?? [],
        ["Nombre", "nombre"],
        ["pkId", "Id", "id"]
      );
    } finally {
      this.afterProductosOptionsRefresh();
    }
  }

  /** Depois de trocar `productosOptions`, o datalist re-renderiza; reaplica o latch/erro se ainda faltar produto. */
  private afterProductosOptionsRefresh(): void {
    if (this.isUpdateMode) {
      return;
    }
    if (
      !this.productoSubmitRequiredLatch ||
      !this.hasTipoSeleccionado ||
      !this.idRequeridoVacio(this.editForm.get("ProductoId")?.value)
    ) {
      return;
    }
    const reapply = () => {
      this.productoSubmitRequiredLatch = true;
      const productoCmp = this.headerInputFilters?.find(
        (c) => String(c.formControlText) === "ProductoId"
      );
      productoCmp?.reapplySubmitValidationVisual();
      this.cdRef.detectChanges();
    };
    this.cdRef.detectChanges();
    setTimeout(reapply, 0);
    setTimeout(reapply, 100);
  }

  private async cargarNivelTaxonomia(
    nivel: number,
    nivelPredecesorNombre: string
  ): Promise<void> {
    const header = {
      TXCentroCosteId: this.editForm.get("TXCentroCosteId")?.value,
      TXTipoPrecioId: this.editForm.get("TXTipoPrecioId")?.value,
      TXCanalVentasId: this.editForm.get("TXCanalVentasId")?.value,
    };
    const data = await this.servicioAPI
      .GetTXItemVentasSegunNivel(nivel, nivelPredecesorNombre, header)
      .toPromise();
    const listado =
      data?.DatosResult?.Listado ?? data?.DatosResult?.Lista ?? [];
    this.txNiveles[nivel] = listado;
    if (nivel > 1) {
      this.actualizarValidadorNivel(nivel, listado.length > 0);
      if (!listado.length) {
        this.editForm.patchValue({ [`Nivel${nivel}`]: null }, { emitEvent: false });
      }
    }
  }

  private syncHeaderInputFiltersToForm(): void {
    const names = new Set([
      "TipoProducto",
      "ProductoId",
      "TXCentroCosteId",
      "TXTipoPrecioId",
      "TXCanalVentasId",
      "TXAlojamientoId",
    ]);
    const list = this.headerInputFilters;
    if (!list?.length) {
      return;
    }
    list.forEach((cmp) => {
      const name = cmp.formControlText != null ? String(cmp.formControlText) : "";
      if (!name || !names.has(name)) {
        return;
      }
      const ctrl = this.editForm.get(name);
      if (!ctrl) {
        return;
      }
      const raw = cmp.getSyncValueForParentForm();
      let value = this.parseIncomingInputFilterValue(raw);
      if (value === null) {
        const vis = cmp.getAnswerVisibleForSync();
        if (
          !this.valorVacio(vis) &&
          !this.skipProductoResolveFromVisible(name, vis)
        ) {
          value = this.resolveValueByVisibleText(name, vis);
        }
      }
      if (value !== null) {
        ctrl.setValue(value, { emitEvent: false });
      } else {
        const vis = cmp.getAnswerVisibleForSync();
        if (this.valorVacio(vis)) {
          ctrl.setValue(null, { emitEvent: false });
        }
      }
      ctrl.updateValueAndValidity({ emitEvent: false });
    });
  }

  async submit() {
    this.editForm.markAllAsTouched();
    this.syncHeaderInputFiltersToForm();
    this.submitValidationTick++;

    const submitValidation = this.resolveSubmitValidation();
    if (!submitValidation.ok) {
      this.snackbar.openSnackBar(
        submitValidation.message ||
          this.translation?.FaltanCamposObligatorios ||
          "Faltan campos obligatorios",
        "",
        "red-snackbar"
      );
      this.productoSubmitRequiredLatch =
        !this.isUpdateMode &&
        this.hasTipoSeleccionado &&
        this.idRequeridoVacio(this.editForm.get("ProductoId")?.value);
      this.cdRef.detectChanges();
      setTimeout(() => {
        const productoCmp = this.headerInputFilters?.find(
          (c) => String(c.formControlText) === "ProductoId"
        );
        productoCmp?.reapplySubmitValidationVisual();
        if (
          !this.isUpdateMode &&
          this.hasTipoSeleccionado &&
          this.idRequeridoVacio(this.editForm.get("ProductoId")?.value)
        ) {
          this.productoSubmitRequiredLatch = true;
        }
        this.cdRef.detectChanges();
      }, 0);
      /* Blur após o clique em Guardar pode sincronizar depois; reafirmar o latch se o produto continua vazio. */
      setTimeout(() => {
        if (
          !this.isUpdateMode &&
          this.hasTipoSeleccionado &&
          this.idRequeridoVacio(this.editForm.get("ProductoId")?.value)
        ) {
          this.productoSubmitRequiredLatch = true;
          this.cdRef.detectChanges();
        }
      }, 150);
      return;
    }
    this.productoSubmitRequiredLatch = false;
    this.editForm.patchValue(
      { TXItemVentasId: submitValidation.txItemVentasId || null },
      { emitEvent: false }
    );

    const fv = this.editForm.getRawValue();
    const ctx = this.otherProps || {};
    let productoId = +fv.ProductoId;
    if (
      (this.isUpdateMode || this.isDuplicateMode) &&
      (!Number.isFinite(productoId) || productoId <= 0)
    ) {
      productoId = Number(ctx.ProductoId ?? 0);
    }
    if (!Number.isFinite(productoId) || productoId <= 0) {
      this.snackbar.openSnackBar(
        this.translation?.CampoRequerido ||
          `${this.labelByControl("ProductoId")}: id inválido`,
        "",
        "red-snackbar"
      );
      return;
    }
    const payload = {
      pkId: +(fv.pkId || 0),
      TipoProducto: +fv.TipoProducto,
      ProductoId: productoId,
      TXCentroCosteId: +fv.TXCentroCosteId,
      TXCanalVentasId: +fv.TXCanalVentasId,
      TXTipoPrecioId: +fv.TXTipoPrecioId,
      TXItemVentasId: +fv.TXItemVentasId,
      TXAlojamientoId: this.showAlojamiento ? +(fv.TXAlojamientoId || 0) : 0,
    };
    this.loading = true;
    this.servicioAPI
      .InsUpdProductoTaxonomia(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (resp) => {
          this.loading = false;
          if (resp?.Mensajes?.length) {
            this.snackbar.openSnackBar(
              resp.Mensajes[0].DescripcionMensaje || "Error",
              "",
              "red-snackbar"
            );
            return;
          }
          this.snackbar.openSnackBar(
            this.translation?.MensajeSuccessSnackBar ||
              this.translation?.GuardadoCorrectamente ||
              "Guardado correctamente",
            "",
            "green-snackbar"
          );
          this.productoSubmitRequiredLatch = false;
          this.itemVentaTxDuplicateProductoFlow = false;
          this.itemVentaTxDuplicateLastProductoIdSinModal = null;
          this.panelService.setSavePanel(null);
          this.panelService.setDiscardChanges(true);
          this.panelService.setClosePanel(null);
        },
        (error) => {
          this.loading = false;
          this.httpErrorService.identificarErrores(error);
        }
      );
  }
}
